var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.tabbedPromos'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const dropdownToggle = widget.querySelector(".dropdown-toggle");
        const dropdownItems = Array.from(widget.querySelectorAll(".dropdown-item[data-bs-toggle='tab']"));

        if (!dropdownToggle || dropdownItems.length === 0) {
            return;
        }

        // Avoid Bootstrap's delegated tab data-api on dropdown items.
        // We drive tab activation manually to keep desktop tabs and mobile dropdown in sync.
        dropdownItems.forEach((item) => {
            item.removeAttribute("data-bs-toggle");
        });

        const setDropdownSelection = (selectedItem) => {
            dropdownItems.forEach((item) => {
                item.setAttribute("aria-selected", item === selectedItem ? "true" : "false");
            });
        };

        const syncDropdownToggleFromItem = (selectedItem) => {
            if (!selectedItem) {
                return;
            }

            const accentColor = selectedItem.getAttribute("data-accent-color") || "";
            dropdownToggle.setAttribute("data-accent-color", accentColor);

            const toggleGroupName = dropdownToggle.querySelector(".group-name");
            const itemGroupName = selectedItem.querySelector(".group-name");
            if (toggleGroupName && itemGroupName) {
                toggleGroupName.innerHTML = itemGroupName.innerHTML;
            }

            const toggleIcon = dropdownToggle.querySelector(".widget-icon, .icon");
            const itemIcon = selectedItem.querySelector(".widget-icon, .icon");
            if (toggleIcon && itemIcon) {
                toggleIcon.outerHTML = itemIcon.outerHTML;
            }
        };

        const syncFromTabTarget = (target) => {
            if (!target) {
                return;
            }

            const selectedDropdownItem = dropdownItems.find((item) => item.getAttribute("data-bs-target") === target);
            if (!selectedDropdownItem) {
                return;
            }

            setDropdownSelection(selectedDropdownItem);
            syncDropdownToggleFromItem(selectedDropdownItem);
        };

        // Keep dropdown in sync when any tab button (desktop or mobile) is shown.
        widget.addEventListener("shown.bs.tab", (event) => {
            const shownTab = event.target;
            const target = shownTab?.getAttribute("data-bs-target");
            syncFromTabTarget(target);
        });

        // Keep tab state and dropdown UI in sync when a dropdown item is selected.
        dropdownItems.forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                event.stopPropagation();

                setDropdownSelection(item);
                syncDropdownToggleFromItem(item);

                const target = item.getAttribute("data-bs-target");
                const desktopTabTrigger = widget.querySelector(`.nav-link[data-bs-toggle='tab'][data-bs-target='${target}']`);
                if (desktopTabTrigger) {
                    const tab = bootstrap.Tab.getOrCreateInstance(desktopTabTrigger);
                    tab.show();
                }
            });
        });

        const initiallyActiveTab = widget.querySelector(".nav-link.active[data-bs-toggle='tab'], .dropdown-item.active[data-bs-toggle='tab']");
        const initialTarget = initiallyActiveTab?.getAttribute("data-bs-target") || dropdownItems[0].getAttribute("data-bs-target");
        syncFromTabTarget(initialTarget);
    };

    return {
        initialize
    };

})();